<script setup lang="ts">
    import { LanguageModel } from 'models'
    import { modelLabelKey } from './constants'
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'

    const props = defineProps<{
        modelName?: string | LanguageModel
    }>()

    const { t: $t, te: $te } = useI18n()

    const CUSTOM_ICON_BRANDS = ['zai', 'moonshotai']

    const languageModel = computed(() => {
        return props.modelName?.split('/')?.[1]
    })
    const brand = computed(() => {
        return props.modelName?.split('/')?.[0]
    })
    const bradIcon = computed(() => {
        if (brand.value === 'alibaba') {
            return 'ri:alibaba-cloud-fill'
        }
        if (brand.value === 'spacexai') {
            return 'bxl:xai'
        }
        if (brand.value === 'zai') {
            return 'zai'
        }
        if (brand.value === 'moonshotai') {
            return 'moonshotai'
        }
        return `ri:${brand.value}-fill`
    })
    const brandIconPrefix = computed(() =>
        CUSTOM_ICON_BRANDS.includes(brand.value ?? '') ? 'custom' : undefined,
    )
</script>

<template>
    <div class="flex gap-6 items-center">
        <VvIcon
            :name="bradIcon"
            :prefix="brandIconPrefix"
            class="shrink-0"
            :title="brand" />
        <span class="truncate">
            {{
                $te(modelLabelKey(modelName))
                    ? $t(modelLabelKey(modelName))
                    : languageModel
            }}
        </span>
    </div>
</template>
